import { useContext } from 'react';
import useNRQuery from '../../graphql/useNRQuery';
import useNRPaginatedQuery from '../../graphql/useNRPaginatedQuery';
import ActivityFeedContent from './NRActivityFeedContent';
import { ComponentContext } from '../../ContextWrappers/NRComponentContextWrapper';
import { GET_ACTIVITY, GET_ACTIVITY_TOTAL_COUNT } from '../../graphql/queries/asset';

function NRActivityFeedContainer({ handleClose }) {
  const { asset } = useContext(ComponentContext);

  const [assetActivity, loadingGetAssetActivity] = useNRQuery({
    query: GET_ACTIVITY,
    options: {
      fetchPolicy: 'no-cache',
      variables: {
        args: {
          cursor: { first: 10000 },
          assetId: asset?.id
        }
      }
    },
    qlObjKey: 'activity',
    defaultValue: [],
    transformData: data => {
      const toReturn = data?.edges?.map(item => item.node);
      return toReturn;
    }
  });

  const [, , , , , activityTotalCount] = useNRPaginatedQuery({
    query: GET_ACTIVITY_TOTAL_COUNT,
    options: {
      fetchPolicy: 'no-cache',
      variables: {
        args: {
          cursor: { first: 1 },
          assetId: asset?.id
        }
      }
    },
    qlObjKey: 'activity',
    defaultValue: null
  });

  return (
    <ActivityFeedContent
      exportToCsvConfig={{
        qlArgs: {
          assetId: asset?.id
        }
      }}
      handleClose={handleClose}
      activity={assetActivity}
      isLoading={loadingGetAssetActivity}
      totalCount={activityTotalCount}
    />
  );
}
export default NRActivityFeedContainer;
